<i18n>
{
  "fr": {
    "form-title": "Formulaire pour demande d'extraction de données des eaux souterraines",
    "start-step-title": "Informations",
    "applicant-step-title": "Auteur de la demande",
    "part-of-request-step-title": "Cadre de la demande",
    "data-description-step-title": "Description",
    "end-step-title": "Fin",
    "welcome-title": "Bienvenue",
    "greetings": "Merci de compléter ce formulaire pour que nous puissions connaître au mieux vos besoins afin de traiter votre requête le plus efficacement possible.<br />Pour rappel, il est possible d'utiliser <a href='https://strates-vs.crealp.ch/'>STRATES-VIEWER</a> pour extraire les données quantitatives courrantes.",
    "next-label": "Suivant",
    "back-label": "Précédent",
    "project-name": "Nom du projet",
    "request-type": "Cadre de la demande *",
    "is-public": "Projet public",
    "is-private": "Projet privé",
    "is-academic": "Étude académique",
    "is-other": "Autre étude",
    "reccurency": "Demande récurrente",
    "yes": "Oui",
    "no": "Non",
    "estimate-frequency": "Fréquence estimée",
    "weekly": "Hebdomadaire",
    "monthly": "Mensuelle",
    "quarterly": "Trimestrielle",
    "biannual": "Semestrielle",
    "yearly": "Annuelle",
    "multiYear": "Pluri-annuelle",
    "at-least-one-required": "Au moins un choix doit être sélectionné",
    "geographical-description-placeholder": "Exemple:\n- Zone d'intérêt [Xmin, Ymin, Xmax, Ymax]\n- Station 05X81, AP89, B34 etc.\n- Parcelle xxxx - Ardon",
    "geographical-description-label": "Description de la zone d'intérêt",
    "data-description-label": "Description des données souhaitées",
    "data-description-placeholder": "Exemple:\n- Séries temporelles de niveaux et température, du 01.01.1985 au 01.01.2000: données brutes et moyennes journalières\n- Produits cartographiques (isopièzes, épaisseur de la zone non saturée) sur la zone d'intérêt décrite précédemment.",
    "other-info-label": "Compléments d'informations",
    "other-info-placeholder": "Autres informations complémentaires pour nous aider à traiter au mieux votre demande.\nExemple:\n- Format des données désiré: .txt .xls .csv .shp ...\n- Information sur le(s) station(s) de mesure: état, avec ou sans télétransmission, appartenance à un réseau (SEN, SDANA, ...)",
    "required": "Ce champs est requis",
    "send": "Transmettre",
    "thank-you-title": "Merci",
    "thanks": "Nous prendrons contact avec vous dans les meilleurs délais pour répondre à votre demande. Merci d'avance pour votre patience."
  },
  "de": {

  }
}
</i18n>

<template>
  <div id="collect-data-gw" class="geo-forms">

    <Header :title="$t('form-title')" />

    <md-content class="md-layout md-elevation-3 main-container">

      <md-steppers class="form-steps" md-vertical :md-active-step="activeStep" :md-linear="true">
        <md-step
          id="start"
          :md-label="$t('start-step-title')"
          @click="activeStep = 'start'"
        >
          <h2>{{ $t('welcome-title') }}</h2>

          <p v-html="$t('greetings')"></p>

          <div class="navigation-step-panel">
            <md-button class="md-raised md-primary" @click="goto('applicant')">{{ $t('next-label') }}</md-button>
          </div>
        </md-step>
        <md-step
          id="applicant"
          :md-label="$t('applicant-step-title')"
          @click="activeStep = 'applicant'"
        >
          <ContactForm
            :contact="form.applicant"
            :contacts="contacts"
            v-on:change="onApplicantChange"
            :validations="applicantValidationRules"
            ref="applicantForm"
            v-if="activeStep === 'applicant'"
            :showPostalAddress="false"
          />

          <div class="navigation-step-panel">
            <md-button class="md-raised md-primary" @click="goto('part-of-request')">{{ $t('next-label') }}</md-button>
          </div>
        </md-step>
        <md-step
          id="part-of-request"
          :md-label="$t('part-of-request-step-title')"
          @click="activeStep = 'part-of-request'"
        >
          <md-field>
            <label>{{ $t('project-name') }}</label>
            <md-input v-model="form.projectName"></md-input>
          </md-field>

          <div class="request-type section">
            <div class="md-layout">
              <h4 class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-15">{{ $t('request-type') }}</h4>
              <md-checkbox class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-15"  v-model="form.requestType.isPublic">{{ $t('is-public') }}</md-checkbox>
              <md-checkbox class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-15"  v-model="form.requestType.isPrivate">{{ $t('is-private') }}</md-checkbox>
              <md-checkbox class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-15"  v-model="form.requestType.isAcademic">{{ $t('is-academic') }}</md-checkbox>
              <md-checkbox class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-15"  v-model="form.requestType.isOther">{{ $t('is-other') }}</md-checkbox>
            </div>
            <span class="md-error" v-if="showError && !isPartOfRequestStepValid">{{ $t('at-least-one-required') }}</span>
          </div>

          <div class="reccurency section">
            <div class="md-layout">
              <h4 class="md-layout-item md-xsmall-size-100 md-medium-size-30 md-size-15">{{ $t('reccurency') }}</h4>
              <md-radio class="md-layout-item md-xsmall-size-100 md-medium-size-20 md-size-10"  v-model="form.isReccurent" :value="true">{{ $t('yes') }}</md-radio>
              <md-radio class="md-layout-item md-xsmall-size-100 md-medium-size-20 md-size-10"  v-model="form.isReccurent" :value="false">{{ $t('no') }}</md-radio>
            </div>
            <div class="md-layout estimate-frequency" v-if="form.isReccurent">
              <h4 class="md-layout-item md-xsmall-size-100 md-medium-size-20 md-size-15">{{ $t('estimate-frequency') }}</h4>
              <md-checkbox class="md-layout-item md-xsmall-size-100 md-medium-size-20 md-size-10"  v-model="form.estimateFrequency.weekly">{{ $t('weekly') }}</md-checkbox>
              <md-checkbox class="md-layout-item md-xsmall-size-100 md-medium-size-20 md-size-10"  v-model="form.estimateFrequency.monthly">{{ $t('monthly') }}</md-checkbox>
              <md-checkbox class="md-layout-item md-xsmall-size-100 md-medium-size-20 md-size-10"  v-model="form.estimateFrequency.quarterly">{{ $t('quarterly') }}</md-checkbox>
              <md-checkbox class="md-layout-item md-xsmall-size-100 md-medium-size-20 md-size-10"  v-model="form.estimateFrequency.biannual">{{ $t('biannual') }}</md-checkbox>
              <md-checkbox class="md-layout-item md-xsmall-size-100 md-medium-size-20 md-size-10"  v-model="form.estimateFrequency.yearly">{{ $t('yearly') }}</md-checkbox>
              <md-checkbox class="md-layout-item md-xsmall-size-100 md-medium-size-20 md-size-10"  v-model="form.estimateFrequency.multiYear">{{ $t('multiYear') }}</md-checkbox>
            </div>
          </div>

          <div class="navigation-step-panel">
            <md-button class="md-raised" @click="goto('applicant', true)">{{ $t('back-label') }}</md-button>
            <md-button class="md-raised md-primary" @click="goto('data-description')">{{ $t('next-label') }}</md-button>
          </div>
        </md-step>
        <md-step
          id="data-description"
          class="data-description"
          :md-label="$t('data-description-step-title')"
          @click="activeStep = 'data-description'"
        >
          <label>{{ $t('geographical-description-label') }}</label>
          <md-field :class="{'md-invalid': showError && form.geographicalDescription === ''}">
            <md-textarea v-model="form.geographicalDescription" :placeholder="$t('geographical-description-placeholder')" required></md-textarea>
            <span class="md-error" v-if="showError && form.geographicalDescription === ''">{{ $t('required') }}</span>
          </md-field>

          <label>{{ $t('data-description-label') }}</label>
          <md-field :md-inline="true" :class="{'md-invalid': showError && form.dataDescription === ''}">
            <md-textarea v-model="form.dataDescription" :placeholder="$t('data-description-placeholder')" required></md-textarea>
            <span class="md-error" v-if="showError && form.dataDescription === ''">{{ $t('required') }}</span>
          </md-field>

          <label>{{ $t('other-info-label') }}</label>
          <md-field :md-inline="true" >
            <md-textarea v-model="form.otherInfo" :placeholder="$t('other-info-placeholder')"></md-textarea>
          </md-field>

          <div class="navigation-step-panel">
            <md-button class="md-raised" @click="goto('part-of-request', true)">{{ $t('back-label') }}</md-button>
            <md-button class="md-raised md-primary" @click="send()">{{ $t('send') }}</md-button>
          </div>
        </md-step>
        <md-step
          id="end"
          :md-label="$t('end-step-title')"
          @click="activeStep = 'end'"
        >
          <h2>{{ $t('thank-you-title') }}</h2>

          <p>{{ $t('thanks') }}</p>
        </md-step>
      </md-steppers>
    </md-content>

    <Snackbar ref="snackbar" />

  </div>
</template>

<script>

import 'ol/ol.css'
import { validationMixin } from 'vuelidate'
import {
  required,
  email
} from 'vuelidate/lib/validators'
import {
  mustBeSwissPhoneNumber
} from '@/helpers/field-validators'

import FormQueryDataGW from '@/models/FormQueryDataGW/Form'

import ContactForm from '@/components/contact-form'
import Header from '@/components/header'
import Snackbar from '@/components/snackbar'

const applicantValidationRules = {
  companyName: {
    required
  },
  address: {

  },
  zip: {

  },
  city: {

  },
  firstName: {
    required
  },
  lastName: {
    required
  },
  phone: {
    mustBeSwissPhoneNumber
  },
  email: {
    email,
    required
  }
}

export default {
  name: 'FormQueryDataGW',
  components: {
    ContactForm,
    Header,
    Snackbar
  },
  mixins: [validationMixin],
  computed: {
    isApplicantStepValid () {
      this.$refs.applicantForm.$v.$touch()
      return !this.$refs.applicantForm.$v.$invalid
    },
    isPartOfRequestStepValid () {
      // Au moins un requestType doit être renseigné
      let requestType = this.form.requestType.isPublic || this.form.requestType.isPrivate || this.form.requestType.isAcademic || this.form.requestType.isOther
      return requestType
    },
    isDataDescriptionValid () {
      return this.form.geographicalDescription !== '' && this.form.dataDescription !== ''
    },
    applicantValidationRules () {
      return applicantValidationRules
    }
  },
  data () {
    return {
      form: new FormQueryDataGW(),
      contacts: [],
      activeStep: 'start',
      showError: false
    }
  },
  methods: {
    getValidationClass (rootName, fieldName) {
      let field

      if (typeof fieldName === 'undefined') {
        field = this.$v.form[rootName]
      } else {
        field = this.$v.form[rootName][fieldName]
      }

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    onApplicantChange (contact) {
      this.form.applicant = contact
    },
    goto (stepName, force = false) {
      this.showError = false

      if (force) {
        this.activeStep = stepName
        return
      }

      switch (stepName) {
        case 'part-of-request':
          if (this.isApplicantStepValid) this.activeStep = stepName
          else this.showError = true
          break
        case 'data-description':
          if (this.isPartOfRequestStepValid) this.activeStep = stepName
          else this.showError = true
          break
        default:
          this.activeStep = stepName
          break
      }
    },
    send () {
      if (!this.isDataDescriptionValid) {
        this.showError = true
        return
      }

      this.showError = false
      this.form.lang = this.$i18n.locale
      this.form.save().then(() => {
        this.activeStep = 'end'
      }).catch(this.handleError)
    },
    handleError (e) {
      this.$refs.snackbar.showError(e)
    }
  }
}
</script>

<style lang="scss">

.flex-container {
  display: flex;
}

.group-field {
  padding: 20px;

  &.narrow {
    .md-layout-item {
      padding: 7px;
      margin: 5px;
    }
  }
}

.data-form.section {
  padding-top: 25px;
  padding-bottom: 35px;

  h3 {
    font-size: 1.5em;
    margin-top: 0px;
  }
}

.map {
  width: 100%;
  height:400px;
}

.md-layout-item {
  padding: 10px;
}

.md-menu-content-bottom-start.md-menu-content-small.md-menu-content.md-theme-default {
  @media(max-width: 960px) {
    left: 10px !important;
    max-width: calc(100% - 20px);
  }
  @media(min-width: 960px){
    max-width: 50%
  }
}

.navigation-step-panel {
  text-align: right;
}

.change-form-status-menu {
  margin-top: 6px;
}

.form-steps {
  width: 100%;
  @media(max-width: 600px) {
    padding: 0px !important;
  }
}

.form-tabs {
  margin-bottom: 12px;
}

@media(min-width: 1260px) {
  .md-layout-item.md-size-20 {
    min-width: 19% !important;
    max-width: 19% !important;
    flex: 0 1 19% !important;
  }
}

.request-type {
  .md-error {
    color: var(--md-theme-default-fieldvariant, #ff1744);
    display: block;
    margin-top: -24px;
    margin-left: 10px;
  }
}

.estimate-frequency {
  margin-top: -30px;
}

.data-description {
  .md-field {
    margin-bottom: 35px;
  }
}
</style>
